import { render, staticRenderFns } from "./ButtonBulkReturn.vue?vue&type=template&id=3c757151&scoped=true"
import script from "./ButtonBulkReturn.vue?vue&type=script&lang=js"
export * from "./ButtonBulkReturn.vue?vue&type=script&lang=js"
import style0 from "./ButtonBulkReturn.vue?vue&type=style&index=0&id=3c757151&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c757151",
  null
  
)

export default component.exports